export default function buildCanonicalUrl(
  router, routeName, params = {}, currentQuery = {}, allowedParams = [],
) {
  const { route } = router.resolve({ name: routeName, params });
  const keptQuery = allowedParams.reduce((acc, key) => {
    if (currentQuery[key] !== undefined) {
      acc[key] = currentQuery[key];
    }
    return acc;
  }, {});
  const queryKeys = Object.keys(keptQuery);
  const queryString = queryKeys.length
    ? `?${queryKeys.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(keptQuery[key])}`).join('&')}`
    : '';
  return `${window.location.origin}${route.fullPath}${queryString}`;
}



// WEBPACK FOOTER //
// ./src/utils/canonical-url.js